<template>
  <div>
    <section class="main" v-if="MProductData.MProduct != null">
      <div class="container">
        <div class="img-box">
          <img :src="MProductData.SiteUrl + MProductData.MProduct.o_maas_pt_photo" alt="" />
        </div>
        <div class="box">
          <!-- 0517 新增 title-box div -->
          <div class="title-box">
            <h1>{{ MProductData.MProduct.o_maas_pt_name_zh_tw }}</h1>
            <div style="display: flex" v-html="MProductData.MProduct.o_maas_pt_transport"></div>
            <div class="price">
              <p v-if="MProductData.MProduct.o_maas_pt_ori_price > 0">
                NTD{{ MProductData.MProduct.o_maas_pt_ori_price }}
              </p>
              <p v-if="MProductData.MProduct.o_maas_pt_ori_price == 0"></p>
              <p>NTD</p>
              <p>{{ MProductData.MProduct.o_maas_pt_price }}</p>
            </div>
            <!-- 0607 新增 hr -->
            <hr />
            <!-- 0607 新增 ul -->
            <ul class="main-box">
              <li>
                <div>{{ $t("類型") }}</div>
                <div v-if="MProductData.MProduct.o_maas_pt_code_type == 1">
                  {{ $t("實體卡片") }}
                </div>
                <div v-if="MProductData.MProduct.o_maas_pt_code_type == 2">
                  QR Code
                </div>
              </li>
              <li>
                <div>{{ $t("天數") }}</div>
                <div>
                  {{ MProductData.MProduct.o_maas_pt_expire }}{{ $t("天") }}
                </div>
              </li>
              <li v-if="MProductData.MProduct.o_maas_pt_bonus > 0">
                <div>{{ $t("贈送點數") }}</div>
                <div>
                  {{ MProductData.MProduct.o_maas_pt_bonus }}{{ $t("點") }}
                </div>
              </li>
              <hr />
              <!-- <li style="padding-bottom: 0;" v-if="IsTester">
                <div style="margin-left: 20px;">
                  <input id="AutoYBConnect" class="form-check-input" type="checkbox" v-model="AutoYBConnect" />
                  <label class="form-check-label" for="AutoYBConnect">
                    {{ $t("自動綁定 YouBike 優惠序號") }}
                  </label>
                </div>
              </li>
              <li style="padding-top: 0;" v-if="IsTester">
                <div style="margin-left: 20px; color: red; font-size: 1rem;">
                  系統啟用後，將自動綁定 YouBike 優惠序號，並以您最近一次使用的 YouBike 帳號作為依據。
                </div>
              </li>
              <hr v-if="IsTester" /> -->
              <li>
                <div>{{ $t("優惠券代碼") }}</div>
                <button style="padding: 1px 10px" @click="checkCoupon()">
                  <!-- <img src="img/icon-tick.png" alt="" /> -->
                  {{ $t("套用優惠券") }}
                </button>
              </li>
              <div>
                <input type="text" class="form-control" id="couponCode" name="couponCode" :placeholder="$t('請輸入優惠券碼')"
                  v-model="CouponCode" maxlength="20" />
              </div>
              <hr />
              <li class="total" v-if="!UseCoupon">
                <div>{{ $t("總計") }}</div>
                <div>
                  NTD <span>{{ MProductData.MProduct.o_maas_pt_price }}</span>
                </div>
              </li>
              <li class="total" v-if="UseCoupon">
                <div>{{ $t("總計(套用優惠券)") }}</div>
                <div>
                  NTD <span>{{ CouponPrice }}</span>
                </div>
              </li>
            </ul>
            <hr />
            <div>
              <h1>{{ $t("套票啟用日(購買後無法更改)") }}</h1>
              <div class="form-group"
                v-show="PayType == 0 || PayType == 1 || PayType == 3 || PayType == 5 || PayType == 501">
                <input class="form-control" id="activeDate" name="activeDate" type="date" v-model="ActiveDate" />
              </div>
              <span v-if="PayType == 0 || PayType == 1 || PayType == 3 || PayType == 5 || PayType == 501"
                style="color: red; font-weight: 400;">※請選擇啟用日期</span>
              <span v-if="PayType == 10" class="pay_notes" style="color: red; font-weight: 400;">
                ※訂閱制套票將於購買日
                <span class="pay_notes_time">（{{ todayStr
                }}）</span>
                自動啟用，無需手動選擇。
              </span>
            </div>
            <hr />
            <!-- 0608 新增 -->
            <div v-if="MProductData.NotReviewed">
              <h1>{{ $t("付款方式") }}</h1>
              <div>
                {{ $t("身分資格未審核或審核失敗, 無法購買套票") }}
              </div>
            </div>
            <div v-if="!MProductData.NotReviewed">
              <h1>{{ $t("付款方式") }}</h1>
              <div class="form-group form-check-box">
                <div class="form-check form-check-inline">
                  <input id="payTypeOfiPASSMONEY" class="form-check-input" type="radio" name="payType" value="3"
                    v-model="PayType" />
                  <label class="form-check-label" for="payTypeOfiPASSMONEY">
                    iPASS MONEY
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input id="payTypeOfLINEPay" class="form-check-input" type="radio" name="payType" value="1"
                    v-model="PayType" />
                  <label class="form-check-label" for="payTypeOfLINEPay">
                    LINE PAY
                  </label>
                </div>
                <div class="form-check form-check-inline" v-if="false">
                  <input id="payTypeOfCreditCard" class="form-check-input" type="radio" name="payType" value="0"
                    v-model="PayType" :checked="true" />
                  <label class="form-check-label" for="payTypeOfCreditCard">
                    {{ $t("線上刷卡") }}
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input id="payTypeOfCreditCardNewebPay" class="form-check-input" type="radio" name="payType" value="5"
                    v-model="PayType" />
                  <label class="form-check-label" for="payTypeOfCreditCardNewebPay">
                    {{ $t("線上刷卡") }}
                  </label>
                </div>
                <div class="form-check form-check-inline" v-if="IsTester">
                  <input id="payTypeOfCreditCardNewebPayAndTravelCard" class="form-check-input" type="radio"
                    name="payType" value="501" v-model="PayType" />
                  <label class="form-check-label" for="payTypeOfCreditCardNewebPayAndTravelCard">
                    {{ $t("國民旅遊卡") }}
                  </label>
                </div>
              </div>
              <div class="form-group form-check-box" v-if="MProductData.MProduct.SupportsSubscription">
                <div class="form-check form-check-inline">
                  <input id="payTypeOfSubscription" class="form-check-input" type="radio" name="payType" value="10"
                    v-model="PayType" />
                  <label class="form-check-label" for="payTypeOfSubscription">
                    訂閱制
                  </label>
                </div>
              </div>
              <template v-if="PayType == 501">
                <hr />
                <!-- 點選國民旅遊卡 出現的div  -->
                <div class="nationalTravelCard_box">
                  <h1>填寫國旅卡資料</h1>
                  <div class="form-group">
                    <label class="form-label" for="city">旅遊地區</label>
                    <select id="city" class="form-control" v-model="TravelCardCity">
                      <option value="018">高雄市</option>
                      <option value="016">台南市</option>
                      <option value="020">屏東縣</option>
                      <option value="013">嘉義市</option>
                      <option value="014">嘉義縣</option>
                      <option value="001">台北市</option>
                      <option value="002">基隆市</option>
                      <option value="003">新北市</option>
                      <option value="004">宜蘭縣</option>
                      <option value="005">新竹市</option>
                      <option value="006">新竹縣</option>
                      <option value="007">桃園縣</option>
                      <option value="008">苗栗縣</option>
                      <option value="009">台中市</option>
                      <option value="011">彰化縣</option>
                      <option value="012">南投縣</option>
                      <option value="015">雲林縣</option>
                      <option value="021">台東縣</option>
                      <option value="022">花蓮縣</option>
                      <option value="023">澎湖縣</option>
                      <option value="024">金門縣</option>
                      <option value="025">連江縣</option>
                      <option value="026">南海諸島</option>
                      <option value="027">釣魚台列嶼</option>
                      <option value="028">屏東縣琉球鄉離島</option>
                      <option value="029">台東縣綠島、蘭嶼</option>
                    </select>
                  </div>
                  <div class="date_box">
                    <label class="form-label" for="">旅遊日期</label>
                    <div class="date form-group">
                      <input class="form-control" id="travelCardStartDate" name="travelCardStartDate" type="date"
                        v-model="TravelCardStartDate" placeholder="起始日期" />
                    </div>
                    <div class="date form-group">
                      <input class="form-control" id="travelCardEndDate" name="travelCardEndDate" type="date"
                        v-model="TravelCardEndDate" placeholder="結束日期" />
                    </div>
                  </div>
                </div>
              </template>
              <hr />
              <div class="btn-box" v-if="!IsLogin">
                <router-link :to="{ name: 'Login' }" tag="button">
                  {{ $t("請先登入") }}
                </router-link>
              </div>
              <div class="btn-box" v-if="IsLogin && !MProductData.HasCardMember">
                <router-link :to="{ name: 'CardBind' }" tag="button">
                  {{ $t("請先註冊月週票會員") }}
                </router-link>
              </div>
              <div class="btn-box" v-if="
                IsLogin &&
                MProductData.CanBuyNewMProduct &&
                MProductData.HasCardMember &&
                MProductData.MProduct.o_maas_pt_code_type == 1 &&
                MProductData.HasCard &&
                MProductData.CardStatus == 1
              ">
                <div class="btn-box">
                  <button @click="checkPay">{{ $t("立即購買") }}</button>
                </div>
              </div>
              <div class="btn-box" v-if="
                IsLogin &&
                MProductData.CanBuyNewMProduct &&
                MProductData.HasCardMember &&
                MProductData.MProduct.o_maas_pt_code_type == 1 &&
                (!MProductData.HasCard || MProductData.CardStatus != 1)
              ">
                <div>
                  {{ $t("您尚未綁定卡片，無法購買此類實體卡片月票。") }}
                </div>
              </div>
              <div class="btn-box" v-if="
                IsLogin &&
                MProductData.CanBuyNewMProduct &&
                MProductData.HasCardMember &&
                MProductData.MProduct.o_maas_pt_code_type == 2
              ">
                <div class="btn-box">
                  <button @click="checkPay">{{ $t("立即購買") }}</button>
                </div>
              </div>
              <div class="btn-box" v-if="
                IsLogin &&
                MProductData.HasCardMember &&
                !MProductData.CanBuyNewMProduct
              ">
                {{ MProductData.CanBuyNewMProductDesc || $t("已有啟用中的票卡，無法進行購買") }}
              </div>
            </div>
          </div>
          <hr />
          <!-- 0517 新增 text-box div -->
          <div class="text-box">
            <!-- 0517 新增 h2 -->
            <h2>{{ $t("方案內容") }}</h2>
            <p class="text" v-html="MProductData.MProduct.o_maas_pt_detail_zh_tw"></p>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "類型": "類型",
    "實體卡片": "實體卡片",
    "天數": "天數",
    "天": "天",
    "贈送點數": "贈送點數",
    "點": "點",
    "優惠卷代碼": "優惠卷代碼",
    "總計": "總計",
    "總計(套用優惠卷)": "總計(套用優惠卷)",
    "套票啟用日(購買後無法更改)": "套票啟用日(購買後無法更改)",
    "付款方式": "付款方式",
    "線上刷卡": "線上刷卡",
    "請先登入": "請先登入",
    "請先註冊卡片會員": "請先註冊卡片會員",
    "立即購買": "立即購買",
    "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡": "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡",
    "已有啟用中的票卡，無法進行購買": "已有啟用中的票卡，無法進行購買",
    "方案內容": "方案內容",
    "錯誤": "錯誤",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "取得會員資訊過程發生錯誤, 請稍後再試一次",
    "確定": "確定",
    "請稍候...": "請稍候...",
    "訂單建立過程發生錯誤, 請稍後再試一次": "訂單建立過程發生錯誤, 請稍後再試一次",
    "交易完成": "交易完成",
    "關閉": "關閉",
    "繼續": "繼續",
    "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態": "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態",
    "優惠券代碼": "優惠券代碼",
    "套用優惠券": "套用優惠券",
    "請輸入優惠券碼": "請輸入優惠券碼",
    "總計(套用優惠券)": "總計(套用優惠券)",
    "卡片月票未過卡將比照一般收費扣款。手機過卡上線囉！前往【過卡說明】瞭解詳情。": "卡片月票未過卡將比照一般收費扣款。手機過卡上線囉！前往【過卡說明】瞭解詳情。"
  },
  en: {
    "類型": "Type",
    "實體卡片": "Card",
    "天數": "Amount of days",
    "天": "Day",
    "贈送點數": "Bonus points",
    "點": "Points",
    "優惠卷代碼": "Coupon code",
    "總計": "Total",
    "總計(套用優惠卷)": "Total (after applying coupon)",
    "套票啟用日(購買後無法更改)": "Pass enabling day (cannot change after buying)",
    "付款方式": "Payment",
    "線上刷卡": "Online payment",
    "請先登入": "Please log in",
    "請先註冊卡片會員": "Please register card member",
    "立即購買": "Buy now",
    "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡": "Your card has not been approved or enabled to purchase this pass.",
    "已有啟用中的票卡，無法進行購買": "A ticket already in use cannot be purchased",
    "方案內容": "Content",
    "錯誤": "Error",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "確定": "Confirm",
    "請稍候...": "Wait a second",
    "訂單建立過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    "交易完成": "Thank you",
    "關閉": "Close",
    "繼續": "Continue",
    "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態": "After payment, you will be transfered to the order page to confirm pass.",
    "優惠券代碼": "Coupon Code",
    "套用優惠券": "Use Coupon",
    "請輸入優惠券碼": "Please Enter Coupon Code",
    "總計(套用優惠券)": "Total (with coupon applied)",
    "卡片月票未過卡將比照一般收費扣款。手機過卡上線囉！前往【過卡說明】瞭解詳情。": "If the monthly pass plan has not been activated your card before boarding, the fare will be charged. To know more, please click the right button."
  },
  jp: {
    "類型": "タイプ",
    "實體卡片": "實體卡片",
    "天數": "天數",
    "天": "天",
    "贈送點數": "贈送點數",
    "點": "點",
    "優惠卷代碼": "クーポンコード",
    "總計": "合計",
    "總計(套用優惠卷)": "合計(クーポンを適用)　",
    "套票啟用日(購買後無法更改)": "フリーパスの使用日(購入後は変更できません)",
    "付款方式": "支払い方法",
    "線上刷卡": "クレジットカード",
    "請先登入": "先にログインしてください",
    "請先註冊卡片會員": "請先註冊卡片會員",
    "立即購買": "今すぐ買う",
    "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡": "您的卡片尚未通過審核或尚未啟用，無法購買此類票卡",
    "已有啟用中的票卡，無法進行購買": "已有啟用中的票卡，無法進行購買",
    "方案內容": "プラン内容",
    "錯誤": "エラー",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "会員情報の取得中にエラーが発生しました,時間をおいてから再度お試しください",
    "確定": "確定",
    "請稍候...": "しばらくお待ちください",
    "訂單建立過程發生錯誤, 請稍後再試一次": "購入手続き中にエラーが発生しました,時間をおいてから再度お試しください",
    "交易完成": "ご注文が完了しました",
    "關閉": "閉じる",
    "繼續": "続ける",
    "付款完成後請點選「確定」前往訂單頁面確認套票購買狀態": "支払いが完了したら「確認」をクリックして注文ページに移動し、フリーパスの購入状況を確認してください",
    "優惠券代碼": "クーポンコード",
    "套用優惠券": "クーポンを適用",
    "請輸入優惠券碼": "クーポンコードを入力する",
    "總計(套用優惠券)": "合計(クーポンを適用)",
    "卡片月票未過卡將比照一般收費扣款。手機過卡上線囉！前往【過卡說明】瞭解詳情。": "If the monthly pass plan has not been activated your card before boarding, the fare will be charged. To know more, please click the right button."
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "MProductBuy",
  i18n,
  data() {
    return {
      BuyCount: 1,
      ActiveDate: "",
      MProductData: {},
      IsLogin: Storage.isKey("ek_login_token"),
      PayType: "5",
      PayUrl: "",
      CouponCode: "",
      UseCoupon: false,
      CouponPrice: 0,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      //FixActiveDate: "",
      MaxDay: 0,
      AutoYBConnect: true,
      IsTester: false,
      TravelCardCity: "018",
      TravelCardStartDate: "",
      TravelCardEndDate: "",
    };
  },
  computed: {
    todayStr() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    }
  },
  watch: {
    PayUrl: (newVal, oldVal) => {
      if (newVal != "") {
        window.open(newVal);
      }
    },
    CouponCode(newValue, oldValue) {
      var rules = new RegExp(/[^A-Z0-9]/g);
      if (rules.test(newValue)) {
        this.$nextTick(() => {
          this.CouponCode = newValue.replace(rules, '');
        })
      }
    },
  },
  created: function () {
    let that = this;
    $.ajax({
      url:
        that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/MProductBuy",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
        o_maas_pt_seq: that.$route.params.o_maas_pt_seq,
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得會員資訊過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.MProductData = JSON.parse(res.data);
          that.MaxDay = new Date();
          that.MaxDay = that.MaxDay.setDate(that.MaxDay.getDate() + 30);
          that.IsTester = that.MProductData.IsTester;
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("package-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () {
    let that = this;
    if (that.MProductData.SpecialPackage) {
      $("#activeDate").pickadate({
        format: "yyyy/mm/dd",
        selectYears: true,
        selectMonths: true,
        selectYears: 100,
        min: new Date(2023, 6, 1),
        max: new Date(2023, 6, 31),
        onClose: function () {
          that.ActiveDate = $("#activeDate").val();
        },
      });
    } else if (that.MProductData.SpecialPackage2) {
      $("#activeDate").pickadate({
        format: "yyyy/mm/dd",
        selectYears: true,
        selectMonths: true,
        selectYears: 100,
        min: new Date(2025, 8, 15),
        max: new Date(2025, 9, 14),
        onClose: function () {
          that.ActiveDate = $("#activeDate").val();
        },
      });
    } else if (that.MProductData.SpecialPackage3) {
      $("#activeDate").pickadate({
        format: "yyyy/mm/dd",
        selectYears: true,
        selectMonths: true,
        selectYears: 100,
        min: new Date(2025, 11, 26),
        max: new Date(2026, 0, 25),
        onClose: function () {
          that.ActiveDate = $("#activeDate").val();
        },
      });
    } else {
      $("#activeDate").pickadate({
        format: "yyyy/mm/dd",
        selectYears: true,
        selectMonths: true,
        selectYears: 100,
        min: that.MProductData.FixActiveDate
          ? that.MProductData.FixActiveDate
          : new Date(),
        max: that.MProductData.FixActiveDate
          ? that.MProductData.FixActiveDate
          : new Date(that.MaxDay),
        onClose: function () {
          that.ActiveDate = $("#activeDate").val();
        },
      });
    }
    $("#travelCardStartDate").pickadate({
      format: "yyyy/mm/dd",
      selectYears: true,
      selectMonths: true,
      selectYears: 100,
      onClose: function () {
        that.TravelCardStartDate = $("#travelCardStartDate").val();
      },
    });
    $("#travelCardEndDate").pickadate({
      format: "yyyy/mm/dd",
      selectYears: true,
      selectMonths: true,
      selectYears: 100,
      onClose: function () {
        that.TravelCardEndDate = $("#travelCardEndDate").val();
      },
    });
  },
  methods: {
    checkPay() {
      if (this.UseCoupon) {
        this.$swal({
          heightAuto: false,
          icon: "warning",
          title: "請注意!",
          text: "前往付款後優惠券將會立即失效, 是否確定使用此優惠券?",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonText: "確定",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.isConfirmed) {
            this.gotoPay(false);
          }
        });
      } else if (!this.UseCoupon && this.CouponCode) {
        this.$swal({
          heightAuto: false,
          title: this.$t("提示"),
          text: this.$t("若要套用優惠券碼, 請點選「套用優惠券」"),
          icon: "info",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
      } else {
        this.gotoPay(false);
      }
    },
    gotoPay(isCheck) {
      let that = this;
      // 是否為訂閱制又輸入序號
      if (that.PayType == 10) {
        if (that.CouponCode) {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("訂閱制無法使用優惠券代碼"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        }
        console.log(isCheck)
        if (!isCheck) {
          this.$swal({
            width: 1200,
            heightAuto: false,
            icon: "info",
            title: "",
            html: '<div style="text-align: left;">' + this.MProductData.SubscriptionMsg + '</div>',
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonText: "同意並繼續",
            cancelButtonText: "取消",
          }).then((result) => {
            if (result.isConfirmed) {
              that.gotoPay(true);
            }
          });
          return;
        }
        that.ActiveDate = that.todayStr;
      }
      // 判斷是否為501且未填寫旅遊日期或結束日期早於開始日期
      if (that.PayType == 501) {
        if (!that.TravelCardStartDate || !that.TravelCardEndDate) {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("請填寫旅遊日期"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
          return;
        }
        if (new Date(that.TravelCardEndDate) < new Date(that.TravelCardStartDate)) {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("結束日期不可早於開始日期"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
          return;
        }
      }
      // 顯示請稍候
      that.$swal({
        heightAuto: false,
        title: that.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: function () {
          that.$swal.showLoading();
        },
      });
      // 進入交易環節
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/CreateOrder",
        type: "post",
        data: {
          ProductType: 2,
          o_maas_pt_seq: that.MProductData.MProduct.o_maas_pt_seq,
          ActiveDate: that.MProductData.FixActiveDate
            ? that.MProductData.FixActiveDate
            : that.ActiveDate,
          PayType: that.PayType,
          BuyCount: that.BuyCount,
          CouponCode: that.CouponCode,
          platform:
            that.isMobile && typeof cordova != "undefined"
              ? device.platform
              : "Browser",
          AutoYBConnect: that.AutoYBConnect,
          TravelCardCity: that.TravelCardCity,
          TravelCardStartDate: that.TravelCardStartDate,
          TravelCardEndDate: that.TravelCardEndDate,
          token: Storage.get("ek_login_token"),
        },
        dataType: "json",
        async: false,
        error: function () {
          that.$swal({
            heightAuto: false,
            title: that.$t("錯誤"),
            text: that.$t("訂單建立過程發生錯誤, 請稍後再試一次"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
          });
        },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            if (res.CouponOrder) {
              that.$swal({
                heightAuto: false,
                title: that.$t("交易完成"),
                icon: "success",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
                willClose: function () {
                  // 轉到首頁
                  that.$router.push({
                    name: "OrderInfo",
                    params: { OrderId: res.OrderId },
                  });
                },
              });
            } else {
              if (that.isMobile && typeof cordova != "undefined") {
                if (device.platform == "iOS" || that.PayType == 3) {
                  cordova.InAppBrowser.open(res.PayUrl, "_system");
                } else {
                  cordova.InAppBrowser.open(
                    res.PayUrl,
                    "_blank",
                    "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
                    that.$t("關閉") +
                    ",closebuttoncolor=#ffffff"
                  );
                }
                // 判斷是否為訂閱
                if (that.PayType == 10) {
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("繼續"),
                    text: that.$t("付款完成後，將前往訂單頁面確認套票購買狀態"),
                    icon: "success",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("前往訂單頁面"),
                    willClose: function () {
                      // 轉到首頁
                      that.$router.push({
                        name: "SubscriptionInfo",
                        params: { SubscriptionId: res.SubscriptionId },
                      });
                    },
                  });
                } else {
                  // 跳出視窗等待付款結果
                  if (that.MProductData.MProduct.o_maas_pt_code_type == 1) {
                    that
                      .$swal({
                        heightAuto: false,
                        title: that.$t("繼續"),
                        text: that.$t(
                          "卡片月票未過卡將比照一般收費扣款。手機過卡上線囉！前往【過卡說明】瞭解詳情。"
                        ),
                        icon: "success",
                        allowOutsideClick: false,
                        confirmButtonText: that.$t("前往訂單頁面"),
                        showDenyButton: true,
                        denyButtonText: that.$t("過卡說明"),
                      })
                      .then((result) => {
                        if (result.isConfirmed) {
                          // 轉到首頁
                          that.$router.push({
                            name: "OrderInfo",
                            params: { OrderId: res.OrderId },
                          });
                        } else if (result.isDenied) {
                          // 轉到票卡說明
                          that.$router.push({
                            name: "Post",
                            params: { PId: i18n.locale == "zh_tw" ? 696 : 716 },
                          });
                        }
                      });
                  } else {
                    that.$swal({
                      heightAuto: false,
                      title: that.$t("繼續"),
                      text: that.$t("付款完成後，將前往訂單頁面確認套票購買狀態"),
                      icon: "success",
                      allowOutsideClick: false,
                      confirmButtonText: that.$t("前往訂單頁面"),
                      willClose: function () {
                        // 轉到首頁
                        that.$router.push({
                          name: "OrderInfo",
                          params: { OrderId: res.OrderId },
                        });
                      },
                    });
                  }
                }
              } else {
                location.href = res.PayUrl;
                //window.open(res.PayUrl, "_blank");
              }
            }
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            if (res.toekn_error) {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                willClose: function () {
                  // 移除登入資訊
                  Storage.remove("ek_login_token");
                  // 回到首頁
                  that.$router.push({
                    name: "Home",
                    params: {},
                  });
                },
              });
            } else {
              that.$swal({
                heightAuto: false,
                title: that.$t("錯誤"),
                text: error_msg[i18n.locale],
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: that.$t("確定"),
              });
            }
          }
        },
      });
    },
    checkCoupon() {
      if (this.CouponCode) {
        let that = this;
        $.ajax({
          url:
            that.GLOBAL.apiSrc +
            that.GLOBAL.subDirectory +
            "/Htmlv2/CheckCoupon",
          type: "post",
          data: {
            o_maas_pt_seq: that.MProductData.MProduct.o_maas_pt_seq,
            couponCode: that.CouponCode,
            token: Storage.get("ek_login_token"),
          },
          dataType: "json",
          async: false,
          error: function () {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: that.$t("訂單建立過程發生錯誤, 請稍後再試一次"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          },
          success: function (res) {
            // 判斷結果
            if (res.ok) {
              that.UseCoupon = true;
              that.CouponPrice = res.CouponPrice;
            } else if (res.error_msg) {
              var error_msg = JSON.parse(res.error_msg);
              if (res.toekn_error) {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  willClose: function () {
                    // 移除登入資訊
                    Storage.remove("ek_login_token");
                    // 回到首頁
                    that.$router.push({
                      name: "Home",
                      params: {},
                    });
                  },
                });
              } else {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: error_msg[i18n.locale],
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              }
            }
          },
        });
      } else {
        this.UseCoupon = false;
        this.CouponPrice = 0;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.count {
  border: solid 1px #ff4f48;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  width: 150px;
  justify-content: space-between;
  float: right;
}

.minus,
.add {
  font-size: 15px;
  color: #fff;
  background-color: #ff4f48;
  line-height: 30px;
  width: 35px;
  text-align: center;
  cursor: pointer;
}

.num {
  font-size: 18px;
  text-align: center;
  color: #000;
  display: block;
  flex-basis: 80px;
}

.minus,
.add {
  font-size: 15px;
  color: #fff;
  background-color: #ff4f48;
  line-height: 30px;
  width: 35px;
  text-align: center;
  cursor: pointer;
}

.border-color {
  border: 1px solid #26c6da;
  color: #26c6da;
  border-radius: 20px;
  width: 95px;
  line-height: 35px;
  text-align: center;
}

.color-r {
  border: 1px solid #ff4f48;
  color: #ff4f48;
  background-color: transparent;
}

.package-main label[for="payTypeOfCreditCardNewebPayAndTravelCard"] {
  background-image: url(/img/pay_NationalTravelCard.svg);
}


.nationalTravelCard_box label {
  margin: 0;
}

.nationalTravelCard_box .form-control {
  margin: 10px 0;
}

.nationalTravelCard_box .date_box {
  margin: 20px 0;
}


.nationalTravelCard_box .form-group input.form-control {
  background-color: #fff;
  cursor: pointer;
  position: relative;
  background-image: url(/img/start_date.svg);
  background-repeat: no-repeat;
  background-size: 28px;
  background-position: calc(100% - 5px) 6px;
  padding-right: 32px;
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/components/MProductBuy.vue